import { ModelBase } from '../../core/model/model-base';

export enum RentalObjectKeyHandoverDirection {
  ToTenant = 1,
  ToLandlord = 2,
}

export class RentalObjectKeyHandover extends ModelBase {
  constructor(model?: any) {
    super();
    if (model) {
      this.registeredAt = model.registeredAt;
      this.quantity = model.quantity;
      this.comment = model.comment;
      this.directionCaption = model.directionCaption;
      this.signatories = model.signatories;
      this.eSignatureErrandId = model.eSignatureErrandId;
      this.eSignatureStatusText = model.eSignatureStatusText;
      this.direction = model.direction;
    } else {
      this.registeredAt = new Date();
    }
  }

  registeredAt: Date;
  quantity: number;
  comment: string;
  directionCaption: string;
  direction: RentalObjectKeyHandoverDirection;
  signatories: string;
  eSignatureErrandId: string;
  eSignatureStatusText: string;
}

export class RentalObjectKey extends ModelBase {
  constructor(model?: any) {
    super();
    if (model) {
      this.id = model.id;
      this.rentalObjectId = model.rentalObjectId;
      this.keyTypeId = model.keyTypeId;
      this.quantity = model.quantity;
      this.quantityLentOut = model.quantityLentOut;
      this.systemNumber = model.systemNumber;
      this.marking = model.marking;
      this.key = model.key;
      this.caption = model.caption;
      this.supplier = model.supplier;
      this.companyName = model.companyName;
      this.propertyName = model.propertyName;
      this.rentalId = model.rentalId;
      this.keyTypeName = model.keyTypeName;
      this.handovers = Array.isArray(model.handovers) ? model.handovers.map(h => new RentalObjectKeyHandover(h)) : [];
    } else {
      this.quantity = 1;
      this.quantityLentOut = 0;
      this.handovers = [];
    }
  }

  keyTypeId: string;
  quantity: number;
  systemNumber: string;
  marking: string;
  caption: string;
  key: string;
  supplier: string;
  quantityLentOut: number;
  companyName: string;
  propertyName: string;
  rentalId: string;
  rentalObjectId: string;
  keyTypeName: string;

  handovers: RentalObjectKeyHandover[];
}
